import { SnapType } from '@trimble/web3d-providers';

export const faceSnapType: readonly SnapType[] = [SnapType.FACE];

export const lineSnapType: readonly SnapType[] = [SnapType.LINE];

export const pointSnapType: readonly SnapType[] = [
  SnapType.POINT,
  SnapType.CONTROL_POINT,
  SnapType.MIDPOINT,
  SnapType.PERPENDICULAR_POINT,
  SnapType.INTERSECTION_POINT,
];

export const centerSnapType: readonly SnapType[] = [
  SnapType.CENTER_LINE,
  SnapType.CENTER_POINT,
];
